import { render, staticRenderFns } from "./InspirationList.vue?vue&type=template&id=1eb12fe2"
import script from "./InspirationList.vue?vue&type=script&lang=ts"
export * from "./InspirationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports